module.exports = "/assets/c8a3578c6b33b57ea1808ecb38af7735.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U2.png
// module id = 1876
// module chunks = 0